import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from 'redux-thunk'
import reducers from "./reducers";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { API_ROOT } from "./apis/ApiConfig";

let composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
if (API_ROOT === "https://testcollege.verificationgateway.org/gateway" || API_ROOT === "https://coffeyvillecommunitycollege.verificationgateway.org/gateway" || API_ROOT === "https://tcfinancialaid.verificationgateway.org/gateway") {
  composeEnhancers = compose;
}

const persistConfig = {
  key: "root",
  blacklist: ["alerts", "student"],
  storage: storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
